module.exports = function() {
  return new Worker(__webpack_public_path__ + "d0af3d35e1173f7c6f99.worker.js");
};